var _g, _circle, _path, _path2, _path3, _path4, _path5, _rect, _path6, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAbsentEmployees(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 62,
    viewBox: "0 0 62 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_5452_12747)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 12C12 6.47715 16.4772 2 22 2H40C45.5228 2 50 6.47715 50 12V30C50 35.5228 45.5228 40 40 40H22C16.4772 40 12 35.5228 12 30V12Z",
    fill: "url(#paint0_linear_5452_12747)"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 30.0942,
    cy: 12.9223,
    r: 4.36765,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.3672 20.0264H32.8271V18.7988C36.6189 19.9657 39.375 23.4964 39.375 27.6709V29.0332C39.375 29.9106 38.7846 30.6775 37.9297 30.875C35.9696 31.3279 32.4174 32.0535 29.8359 32.0381C27.4212 32.0236 24.1116 31.3257 22.2451 30.8818C21.3957 30.6797 20.8126 29.9161 20.8125 29.043V27.6709C20.8125 23.4939 23.5719 19.9616 27.3672 18.7969V20.0264Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9062 27.7887L29.071 22.2031H31.1092L32.2739 28.0827L30.2357 29.8465L27.9062 27.7887Z",
    fill: "white",
    stroke: "#F8175F",
    strokeWidth: 1.06356,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9062 20.5703L28.8422 22.7541H31.338L32.2739 20.5703H27.9062Z",
    fill: "white",
    stroke: "#F71660",
    strokeWidth: 1.06356,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27.3635 22.7509L25.7656 20.0825L28.4554 18.6562L30.0933 20.5671L27.3635 22.7509Z",
    fill: "white",
    stroke: "#F8175F",
    strokeWidth: 1.06356,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M32.8208 22.7509L34.3203 20.0231L31.7289 18.6562L30.091 20.5671L32.8208 22.7509Z",
    fill: "white",
    stroke: "#F8175F",
    strokeWidth: 1.06356,
    strokeLinecap: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 22.7891,
    width: 14.75,
    height: 14.75,
    rx: 7.375,
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.3716 24.1641C42.5798 24.1641 45.1804 26.7647 45.1804 29.9729C45.1804 33.1811 42.5798 35.7817 39.3716 35.7817C36.1634 35.7817 33.5625 33.1811 33.5625 29.9729C33.5625 26.7647 36.1634 24.1641 39.3716 24.1641ZM37.9427 27.2252L39.3716 28.654L40.8004 27.2252C41.6727 26.3529 42.9913 27.6717 42.119 28.544L40.6904 29.9729L42.119 31.4017C42.9913 32.274 41.6727 33.5928 40.8004 32.7205L39.3716 31.2917L37.9427 32.7205C37.0704 33.5928 35.7516 32.274 36.6239 31.4017L38.0528 29.9729L36.6239 28.544C35.7516 27.6717 37.0704 26.3529 37.9427 27.2252Z",
    fill: "#F71661"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_5452_12747",
    x: 0,
    y: 0,
    width: 62,
    height: 62,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 4,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect1_dropShadow_5452_12747"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5452_12747"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 3,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect2_dropShadow_5452_12747"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_5452_12747",
    result: "effect2_dropShadow_5452_12747"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_5452_12747",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5452_12747",
    x1: 12,
    y1: 2,
    x2: 50,
    y2: 40,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2056"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E60076"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAbsentEmployees);
export default __webpack_public_path__ + "static/media/Absent Employees.cf6893dab1ea4b94476a7e82918976d7.svg";
export { ForwardRef as ReactComponent };